import getWindow from "../../utils/window";
import { getOOSProducts } from "../../utils/product";
import { setEvents, setLinkTrackEvents } from "../events";
import { getCommons, getGlobalEvars } from "../common";
import { getCommonLooksTrackingValues } from "../looks/common";
import { waitForPageLoadAnalytics } from "../pageLoad";

const trackedLookIndexes = new Set();

export const resetWaysToStyleOutfitViewTracking = () => {
  trackedLookIndexes.clear();
};

export const fireWaysToStyleOutfitView = async ({ products, lookIndex }) => {
  if (trackedLookIndexes.has(lookIndex)) {
    return;
  }

  trackedLookIndexes.add(lookIndex);

  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  const TRACKING_NAME = "waysToStyleOutfitView";

  s.products = products.map(({ id }) => `;${id};;;;`).join(",");

  setEvents({
    events: [
      `event342=${products.length}`,
      `event343=${getOOSProducts(products).length}`,
      "event172",
    ],
    trackingName: TRACKING_NAME,
  });

  s.eVar106 = "btl|outfit|view";

  const commonLooksTracking = getCommonLooksTrackingValues({ products });

  s.tl(true, "o", "btl - outfit view", {
    ...commonLooksTracking,
    linkTrackVars: commons.setLinkTrackVars([
      ...getGlobalEvars(),
      ...Object.keys(commonLooksTracking),
      "eVar106",
    ]),
    linkTrackEvents: setLinkTrackEvents({
      trackingName: TRACKING_NAME,
    }),
  });
};
